import { ArrowUpRight } from 'lucide-react';

export default function ActionArrow() {
  return <span className="action-arrow" aria-hidden="true"><ArrowUpRight size={18} /></span>;
}
